






























































































































































import ApplicationLayoutFluid from "@/layouts/ApplicationLayoutFluid.vue";
import LegendItem from "@/views/facility-statistics/components/LegendItem.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import { ApplicationState, FacilityStatisticsState, FacilityList, SelectedMarkerData } from "@/models";
import FacilityStatisticsModule from "@/store/modules/facility-statistics";

const facilityStatistics = namespace(FacilityStatisticsModule.name);

@Component({
  name: "FacilityOverview",
  components: {
    LegendItem,
    ApplicationLayoutFluid
  }
})
export default class FacilityOverview extends Vue {
  // ===== Store ===== //
  @State("application") private application!: ApplicationState;
  @State("facilityStatistics") private facilityStatistics!: FacilityStatisticsState;
  @facilityStatistics.Action("clearCustomersAndCompetitorsState") public clearCustomersAndCompetitorsState!: () => void;
  @facilityStatistics.Action("getCustomersDensityInfo") public getCustomersDensityInfo!: (facilityId: number) => void;
  @facilityStatistics.Action("getCompetitorsDensityInfo") public getCompetitorsDensityInfo!: (facilityId: number) => void;

  // ===== Data ===== //
  public selectedFacility: FacilityList | null = null;
  public selectedMarker: SelectedMarkerData = {}
  public infoWindowOptions = {
    pixelOffset: {
      width: 0,
      height: -35
    }
  };
  public infoWindowOpened = false;
  public storeSpaceMarker = true;
  public competitorMarker = true;
  public customerMarker = true;
  public radius = true;
  public facilityMarkerOptions = {
    url: require("../../../assets/SS_Facility_Google-Map-Pin_Red.png"),
    scaledSize: { width: 30, height: 45, f: "px", b: "px" }
  }
  public competitorMarkerOptions = {
    url: require("../../../assets/SS_Facility_Google-Map-Pin_Blue.png"),
    scaledSize: { width: 20, height: 35, f: "px", b: "px" }
  }
  public customerMarkerOptions = {
    url: require("../../../assets/SS_Facility_Google-Map-Pin_Green.png"),
    scaledSize: { width: 20, height: 35, f: "px", b: "px" }
  }
  public circleOptions = {
    fillOpacity: 0,
    strokeWeight: 1.5,
    strokeColor: "black"
  }
  public circleRadii = [
    1609.34,
    4828.03,
    8046.72,
    11265.4
  ]

  // ===== Methods ===== //
  public handleMarkerClicked(markerType: string, info: SelectedMarkerData): void {
    this.selectedMarker = { marker_selected: markerType, ...info };
    this.infoWindowOpened = !this.infoWindowOpened;
  }

  // ===== Computed ===== //
  get infoWindowPosition() {
    return this.selectedMarker && this.selectedMarker.latitude
      ? { lat: this.selectedMarker.latitude, lng: this.selectedMarker.longitude }
      : null;
  }

  /* istanbul ignore next */
  get selectedMarkerTitle(): string {
    if (this.selectedMarker && this.selectedMarker.marker_selected === "competitor") {
      return this.selectedMarker.company_name || "";
    } else if (this.selectedMarker && this.selectedMarker.marker_selected === "customer") {
      return `${this.selectedMarker.first_name} ${this.selectedMarker.last_name}`;
    }
    return `${this.selectedMarker.name} (${this.selectedMarker.location_code})`;
  }

  /* istanbul ignore next */
  get selectedMarkerAddress(): string {
    if (this.selectedMarker && !this.selectedMarker.street_address) {
      return "";
    } else if (this.selectedMarker && this.selectedMarker.marker_selected === "competitor") {
      return "";
    }
    return `${this.selectedMarker.street_address},`;
  }

  get selectedMarkerCity(): string | undefined {
    return `${this.selectedMarker.city}, ${this.selectedMarker.state} ${this.selectedMarker.postal_code}`;
  }

  // ===== Watcher ===== //
  /* istanbul ignore next */
  @Watch("selectedFacility")
  public handleCustomerAndCompetitorMap() {
    if (this.selectedFacility) {
      if (this.facilityStatistics.customersDensityList.length || this.facilityStatistics.competitorsDensityList.length) {
        this.clearCustomersAndCompetitorsState();
      }
      this.getCompetitorsDensityInfo(this.selectedFacility.id);
      this.getCustomersDensityInfo(this.selectedFacility.id);
    }
  }
}
